<div class="container mobile-container container-space">
  <div class="box-info">
    <div class="d-flex align-items-center justify-content-between mb-4">
      <div class="Title-account d-flex flex-column align-items-start justify-content-start">
        <span>{{ 'Orders' | translate }}</span>
        <img class="mt-2 d-lg-block d-none"
             src="/icons/line-categories.svg">
      </div>
      <div class="btn-back d-lg-none d-block">
      <span (click)="openBackClicked()">
        {{ 'Back' | translate }}
        <img src="/icons/forward-outline.svg">
      </span>
      </div>
    </div>
    <div (click)="onCreateAddressesClicked()"
         class="add-addresses-box d-flex align-items-center justify-content-center">
    <span>
      <img src="/icons/add-square.svg">
      افزودن آدرس
    </span>
    </div>
    <div (scrolled)="loadOnline()"
         [infiniteScrollDistance]="2"
         [infiniteScrollThrottle]="50"
         infiniteScroll>
      @for (userAddress of userAddresses; track $index) {
        <div class="panel-mobile">
          <div class="col-12 d-flex align-items-start content-address">
            <img (click)="onEditAddressesClicked(userAddress)"
                 class="ms-3 cursor-pointer"
                 src="/icons/edit-3.svg">
            <div class="flex-grow-1 d-flex flex-column">
              <p class="title-address">
                {{ userAddress.Title }}
              </p>
              <p>
                {{ userAddress.Address }}
              </p>
              <span>
              <img src="/icons/call.svg">
                {{ userAddress.Phone }}
            </span>
              <span>
              <img src="/icons/profile.svg">
                {{ userAddress.RecipientFullName }}
            </span>
            </div>
            <img (click)="onUserAddressRemoveClicked(userAddress)"
                 class="ms-3 cursor-pointer"
                 src="/icons/trash.svg">
          </div>
        </div>
        <hr class="res-item">
      }
    </div>
  </div>
</div>
